import {EditorView} from "@codemirror/view";

export function pasteListener(listener) {
  let shift = false;
  return EditorView.domEventHandlers({
    keydown(event) {
      shift = event.shiftKey;
    },
    keyup(event) {
      shift = event.shiftKey;
    },
    paste(event, view) {
      listener(event, view, shift);
    }
  });
}
